<template>
  <div class="brand_list_page" v-wechat-title="page_title">
    <follow @follow="followFn"></follow>
    <div class="brand_list_body" :style="follow ? { 'margin-top': '0.5rem' } : { 'margin-top': '0' }">
      <div
        class="brand_card"
        v-for="(item, index) in brand_list"
        :key="'brand_' + index"
      >
        <div class="brand_card_top">
          <div class="brand_card_identity">
            <img
              class="brand_card_logo"
              :src="item.brandLogo || error_product_img"
              alt=""
              @error="logoErrorHandle"
            />
          </div>
          <van-button
            type="danger"
            round
            native-type="button"
            class="brand_card_enter"
            @click="enterBrandHandle(item)"
          >
            进入
          </van-button>
        </div>
        <p class="brand_card_desc">{{ item.brandDesc }}</p>
        <div class="brand_product_track">
          <div
            class="brand_product_card"
            v-for="(p, pi) in item.productList"
            :key="'p_' + index + '_' + pi"
            @click="productClickHandle(p)"
          >
            <div class="brand_product_thumb">
              <img
                :src="p.img_path || error_product_img"
                :alt="p.name"
                @error="productImgErrorHandle"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="brand_list_empty" v-if="!brand_list.length">暂无品牌专区</div>
    </div>
    <footer-comp :isNewPage="isNewPage" :footer-index="index" :cartnum="cartnum"></footer-comp>
  </div>
</template>

<script>
import footerComp from '../common/footerComp'
import follow from '../common/follow'
import {
  isWeixin,
  fenxiang,
  kefu,
  Base64,
  cartNum,
  goXcxCreateBtnFn,
  clickburiedPoint
} from '../../assets/common/js/config'

export default {
  name: 'brandList',
  data() {
    return {
      page_title: '精选专区',
      brand_list: [],
      follow: null,
      index: 1,
      cartnum: 0,
      isNewPage: 1,
      error_product_img: '/static/images/errorimg.jpg'
    }
  },
  components: {
    footerComp,
    follow
  },
  activated() {
    cartNum((num) => (this.cartnum = num))
    this.getData()
  },
  methods: {
    /** 与 `homepage/json/ajax.js` 中 mock `brand.brandList` 单项结构一致 */
    normalizeStoreZoneProduct(p) {
      if (!p || typeof p !== 'object') {
        return { itemid: '', name: '', img_path: '' }
      }
      var id =
        p.itemid != null
          ? p.itemid
          : p.item_id != null
            ? p.item_id
            : p.id != null
              ? p.id
              : ''
      return {
        itemid: id,
        name: p.name != null ? p.name : p.goods_name || '',
        img_path:
          p.img_path != null
            ? p.img_path
            : p.img || p.image_path || p.image || ''
      }
    },
    normalizeStoreZoneRow(row) {
      if (!row || typeof row !== 'object') {
        return {
          brandType: '',
          brandLogo: '',
          brandDesc: '',
          channelid: '',
          productList: []
        }
      }
      var pl = row.productList || row.goodsList || row.goods_list || []
      if (!Array.isArray(pl)) pl = []
      var that = this
      return {
        brandType:
          row.brandType != null ? row.brandType : row.brand_type || '',
        brandLogo:
          row.brandLogo != null
            ? row.brandLogo
            : row.brand_logo || row.logo || '',
        brandDesc:
          row.brandDesc != null ? row.brandDesc : row.brand_desc || row.desc || '',
        channelid:
          row.channelid != null
            ? row.channelid
            : row.channelId != null
              ? row.channelId
              : row.sortId != null
                ? row.sortId
                : '',
        productList: pl.map(function (x) {
          return that.normalizeStoreZoneProduct(x)
        })
      }
    },
    getData() {
      var that = this
      var url = this.$ajax.getStoreZoneList_URL
      this.$customRequestAjax(url)
        .then(function (res) {
          if (!res.data || res.data.code != 200) {
            that.brand_list = []
            return
          }
          var d = res.data
          var rawList = d.brandList
          if (!Array.isArray(rawList) && d.data && typeof d.data === 'object') {
            rawList = d.data.brandList || d.data.list
          }
          if (!Array.isArray(rawList)) {
            rawList = d.list || []
          }
          if (!Array.isArray(rawList)) {
            that.brand_list = []
            return
          }
          that.brand_list = rawList.map(function (row) {
            return that.normalizeStoreZoneRow(row)
          })
        })
        .catch(function () {
          that.brand_list = []
        })
    },
    followFn: function (data) {
      this.follow = data
    },
    enterBrandHandle(item) {
      this.$app.goChannelIndex(item.channelid)
    },
    productClickHandle(p) {
      this.$app.goItemDetail(p.itemid)
    },
    logoErrorHandle(e) {
      e.target.src = this.error_product_img
      e.target.onerror = null
    },
    productImgErrorHandle(e) {
      e.target.src = this.error_product_img
      e.target.onerror = null
    }
  }
}
</script>

<style scoped lang="scss">
.brand_list_page {
  min-height: 100vh;
  background: #f7f7f7;
  box-sizing: border-box;
}

.brand_list_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 0.44rem;
  padding: 0 0.12rem;
  padding-top: calc(0.1rem + env(safe-area-inset-top, 0px));
  padding-bottom: 0.1rem;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  box-sizing: content-box;
}

.brand_list_back {
  flex-shrink: 0;
  padding: 0.06rem;
  margin-left: -0.06rem;
}

.brand_list_header_title {
  flex: 1;
  text-align: center;
  font-size: 0.17rem;
  font-weight: 500;
  color: #222;
  line-height: 0.24rem;
}

.brand_list_header_spacer {
  width: 0.34rem;
  flex-shrink: 0;
}

.brand_list_body {
  padding: 0.12rem;
  padding-bottom: calc(0.24rem + env(safe-area-inset-bottom, 0px));
}

.brand_card {
  background: #fff;
  border-radius: 0.08rem;
  padding: 0.1rem;
  margin-bottom: 0.1rem;
}

.brand_card_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.08rem;
}

.brand_card_identity {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  padding-right: 0.1rem;
}

.brand_card_logo {
  width: auto;
  height: 0.3rem;
  object-fit: cover;
  flex-shrink: 0;
}

.brand_card_name {
  font-size: 0.15rem;
  font-weight: 600;
  color: #222;
  line-height: 0.21rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand_card_enter {
  flex-shrink: 0;
  height: 0.22rem;
  padding: 0 0.2rem;
  border: none;
}
.brand_card_enter /deep/ .van-button__text {
  font-size: 0.1rem;
  line-height: 0.22rem;
}

.brand_card_desc {
  margin: 0.06rem 0 0.1rem;
  font-size: 0.13rem;
  color: #333333;
  line-height: 0.2rem;
}

.brand_product_track {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.brand_product_card {
  flex: 0 0 auto;
  width: 0.9rem;
  margin-right: 0.06rem;
  &:last-child {
    margin-right: 0;
  }
}

.brand_product_thumb {
  position: relative;
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 0.08rem;
  overflow: hidden;
}

.brand_product_thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.brand_product_mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.28rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.45), transparent);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 0.04rem;
  box-sizing: border-box;
}

.brand_list_empty {
  text-align: center;
  padding: 0.4rem 0.2rem;
  font-size: 0.14rem;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/category/brandList.vue